let nodeIndex = 0;

export const getNodeIndex = () => {
  return nodeIndex++;
}

export const initNodeIndex = () => {
  nodeIndex = 0;
  return false;
}